export var View;
(function(View) {
    View["ENTER_EMAIL"] = "ENTER_EMAIL";
    View["ENTER_PASSWORD"] = "ENTER_PASSWORD";
    View["ENTER_CODE"] = "ENTER_CODE";
    View["ENTER_MFA"] = "ENTER_MFA";
    // Ask user that is linking password account to SSO to enter their password
    View["CONFIRM_PASSWORD"] = "CONFIRM_PASSWORD";
    // Add password to account
    View["CREATE_PASSWORD"] = "CREATE_PASSWORD";
    // Reset password via email
    View["RESET_PASSWORD"] = "RESET_PASSWORD";
    View["LOADING"] = "LOADING";
    // Prompt user that signed up with SSO to hit their social login button
    View["SSO"] = "SSO";
    // Prompt user to select an mfa option if applicable
    View["SELECT_MFA_OPTION"] = "SELECT_MFA_OPTION";
    // Unified login view replacing ENTER_EMAIL and ENTER_PASSWORD
    View["ENTER_LOGIN"] = "ENTER_LOGIN";
    // Shows up after user click magic link for sign in improvements XP
    View["MAGIC_LINK_SENT"] = "MAGIC_LINK_SENT";
    // Shows up after user choose to receive SMS or email code in new MFA experience options
    View["ENTER_MFA_CODE"] = "ENTER_MFA_CODE";
    // Shows up after user choose to receive email code in new MFA experience options
    View["MFA_OPTIONS_EMAIL_SENT"] = "MFA_OPTIONS_EMAIL_SENT";
})(View || (View = {}));
